import Vue from 'vue'
import VtReportExportButtons from '@/components/common/vt-report-export-buttons/vt-report-export-buttons.vue'
Vue.component('VtReportExportButtons', VtReportExportButtons)
